import React from 'react'
import Helmet from 'react-helmet'
import bannerAbout from '../assets/images/mike-hancock-about.jpg'
import bannerAbout2 from '../assets/images/journalism-banner.jpg'

const About = (props) => (
    <div>
        <Helmet>
            <title>About | Mike Hancock | Biography</title>
            <meta name="description" content="After graduating all the way back in 1999 (yes, it seems like a lifetime ago!) 
            I spent a couple of years working as a trainee reporter with a major national newspaper" />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>Mike Hancock</h1>
                        
                    </header>
                    <p>In our area so that people who live in this region can be better informed about the goings on in the community. </p>
                    <span className="image main"><img src={bannerAbout} alt="" /></span>
                    

                    <h2>My background</h2>
                    <p>First, a little about my background. I was born in Portsmouth in 1978 and have spent most of my life here, apart from 3 years studying politics and journalism at the University of 
                    Chester and another couple of years living in London where I learned to appreciate small town living! I’m married to Vicky, a local girl, and I have two children (a 14 year old and a 12 year old) who attend local schools.</p>
                    <hr/>
                    <p>I’m a freelance journalist who submits stories to a number of publications, however, my primary area of interest is following the political machinations here in Hampshire. Being a Portsmouth boy at heart, I have a vested interest in following the comings and goings of our political parties and bringing the latest happenings to the constituents so they can be better informed about the direction that political events in our local area are taking. </p>

                    <hr/>

                    <h3>My Career In Journalism</h3>
                    <p>After graduating all the way back in 1999 (yes, it seems like a lifetime ago!) I spent a couple of years working as a trainee reporter with a major 
                    national newspaper. </p>
                    <span className="image main"><img src={bannerAbout2} alt="" /></span>

                    
                    <p>With my degree background in politics I ended up shadowing one of the most senior journalists in the politics coverage team and 
                    learnt a lot about reading between the lines and picking out the inner meaning behind what the 
                    politicians were saying (or not saying, as is more often the case!) </p>
                
                    <p>I found those formative years instrumental in launching my fascination with politics – not within the national arena which is highly publicised, 
                    but specifically within the local sphere where MPs and representatives seem to work behind the scenes almost unnoticed by their constituents. 
                    Although it seemed to be a step backwards in my career, I decided to move back to my home town so that I could use my newly acquired 
                    journalistic skills to keep the people of Hampshire up to date 
                    with the doings of the people who are supposed to be representing them.</p>
                    <hr/>
                    <h3>My interests</h3>
                    <p>Of course, my primary interest is in digging for news stories in the local area! However, when I’m not keeping my ear firmly to 
                    the ground, I enjoy amateur dramatics and play an active role at my local amdram society! I’ve appeared in two productions over the last year and am looking forward to panto season coming around – this year, I’m determined to be cast as the villain! Of course, it goes without saying that I also love spending time with my 
                    family and enjoying the attractions and beautiful countryside that we’re so lucky to enjoy here in Hampshire.</p>
                
                    <a href="/#header" className="button">BACK HOME</a>
                
                </div>
            </section>
        </div>

    </div>
)

export default About


// WEBPACK FOOTER //
// ./src/pages/about.js